import { apiCall, API } from '../../utils/APIFunctions';

export function get() {
  return apiCall(`${API}/auth`, "GET");
}